import { VideoLectureTypeEnum } from '@crehana/compass.knowledgehub/types';
import { cn } from '@crehana/compass.ui/v2';
import { formatDuration } from '@crehana/date';
import { filterMap, notEmpty } from '@crehana/utils';

import { useCourseDetailCourse, useCourseDetailTranslation } from '../../hooks';
import LessonQuizItem from './lesson-quiz-item';
import LessonVideoItem from './lesson-video-item';
import ToggleItem from './ToggleItem';

const LessonsSection: React.FC = () => {
  const { t } = useCourseDetailTranslation();
  const { course } = useCourseDetailCourse();
  const courseModules = filterMap(course.courseModules || [], e => e);

  const totalModules = courseModules.length;
  let lessonsCounter = 0;
  const lessonMeta = [
    t('MODULES', {
      interpolation: {
        count: totalModules,
      },
    }),
    t('LESSONS_TOTAL', {
      interpolation: {
        count: course.totalLessons,
      },
    }),
  ];

  return (
    <section className="tw-mb-2">
      <h2 className="tw-mb-1.6 tw-font-h5 tw-font-semibold">
        {t('LESSONS_SECTION_TITLE')}
      </h2>
      <p className="tw-mb-2.4 tw-font-body5 sm:tw-font-body4">
        {lessonMeta.map((meta, index) => {
          const isLast = index === lessonMeta.length - 1;

          return (
            <span
              key={meta}
              className={cn(
                'tw-pr-1.2 tw-mr-1.2',
                isLast
                  ? undefined
                  : 'tw-border-r tw-border-solid tw-border-neutral-light-500',
              )}
            >
              {meta}
            </span>
          );
        })}
      </p>

      <ul className="tw-relative tw-mb-9.6 sm:tw-mb-0">
        {courseModules.map((module, indexChild) => {
          const list = module?.videoLectureSet?.filter(notEmpty) || [];

          return (
            <ToggleItem
              key={module.originalId}
              className="tw-mb-1.2"
              indexChildren={indexChild}
              title={module.name}
            >
              <ul aria-label={module.name}>
                {list.map((lesson, index) => {
                  lessonsCounter += 1;

                  const isLast = index === list.length - 1;

                  if (
                    lesson.videoTypeEnum ===
                    VideoLectureTypeEnum.VideoLectureQuiz
                  ) {
                    return (
                      <LessonQuizItem
                        key={`lesson-quiz-${lesson.originalId}`}
                        title={lesson.title}
                        className={isLast ? undefined : 'tw-mb-1.2'}
                      />
                    );
                  }

                  return (
                    <LessonVideoItem
                      title={lesson.title}
                      key={`lesson-video-${lesson.originalId}`}
                      duration={formatDuration(lesson.duration)}
                      className={isLast ? undefined : 'tw-mb-1.2'}
                    />
                  );
                })}
              </ul>
            </ToggleItem>
          );
        })}
      </ul>
    </section>
  );
};

export default LessonsSection;
